// A contact number identifies one guest per booking: it cannot repeat across the
// guests of a room, or across two rooms of the same booking. The backend rejects
// both cases, so these helpers let the guest forms catch it before the save.

export const DUPLICATE_CONTACT_ERROR =
    "This contact is already added to another guest in this booking";

export function normalizeContact(value) {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const digits = String(value).replace(/\D/g, "");
    return digits ? Number(digits) : null;
}

// Contacts held by every room of the booking except the one being edited.
// Rooms come from the booked-rooms list, which carries each room's guests.
export function collectOtherRoomContacts(rooms, currentRoomId) {
    const contacts = new Set();

    (rooms || []).forEach((room) => {
        if (!room || room.id === currentRoomId) {
            return;
        }
        (room.guests || []).forEach((guest) => {
            const contact = normalizeContact(guest?.contact);
            if (contact !== null) {
                contacts.add(contact);
            }
        });
    });

    return contacts;
}

// skipIndex is the guest currently being edited, so re-saving them unchanged is
// not flagged against themselves.
export function isContactTaken(contact, guests, skipIndex = -1, otherRoomContacts = null) {
    const target = normalizeContact(contact);
    if (target === null) {
        return false;
    }

    const takenInThisRoom = (guests || []).some(
        (guest, index) => index !== skipIndex && normalizeContact(guest?.contact) === target,
    );
    if (takenInThisRoom) {
        return true;
    }

    return Boolean(otherRoomContacts && otherRoomContacts.has(target));
}
